import { render, staticRenderFns } from "./TrendStatisticPanel.vue?vue&type=template&id=3a5cb010&scoped=true"
import script from "./TrendStatisticPanel.vue?vue&type=script&lang=js"
export * from "./TrendStatisticPanel.vue?vue&type=script&lang=js"
import style0 from "./TrendStatisticPanel.vue?vue&type=style&index=0&id=3a5cb010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5cb010",
  null
  
)

export default component.exports